const handleStickyButton = () => {
  window.addEventListener('scroll', function() {
    const mainProductForm = document.querySelector('.main-product-form');
    const mainProductFormSticky = document.querySelector('.main-product-sticky-form');

    if (mainProductForm && mainProductFormSticky) {
      const mainProductFormRect = mainProductForm.getBoundingClientRect();
      if (mainProductFormRect.bottom < 0) {
        mainProductFormSticky.classList.add('active');
      } else {
        mainProductFormSticky.classList.remove('active');
      }
    }
  });
}
handleStickyButton();
